/**
 * avvisiPiattaformaService — chi riceve gli avvisi della piattaforma (05/10/2026).
 *
 * Dal 05/10/2026 TUTTI gli avvisi per chi gestisce la piattaforma (server WhatsApp, costi, modelli AI, ticket di
 * assistenza, sessioni condivise, marketing, fotogrammetria, Yuma) vanno a UN SOLO elenco:
 * `platform_config/avvisi_piattaforma.destinatari`. Prima ogni avviso aveva il suo campo (`modelli_ai.avvisi`,
 * `platform_settings/session_enforcement.alert_email`, …): quei campi restano nei documenti ma il server non li legge
 * più, e le pagine della console non devono mostrarli come se valessero.
 *
 * Il server lo legge con `leggiDestinatariAvvisiPiattaforma` (`functions/src/services/email/mittentePiattaforma.ts`);
 * si cambia con `scripts/email/configura-avvisi-piattaforma.cjs --destinatari=… --apply`.
 */
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/** Il documento, dentro `platform_config`. Stesso valore di `DOC_AVVISI_PIATTAFORMA` lato server. */
export const DOC_AVVISI_PIATTAFORMA = 'avvisi_piattaforma';

/** I destinatari scritti nel documento, come li legge il server: testi con la chiocciola, senza doppioni. PURA. */
export function destinatariDelDocumento(dati: unknown): string[] {
  const elenco = (dati as { destinatari?: unknown } | undefined)?.destinatari;
  if (!Array.isArray(elenco)) return [];
  const validi = elenco
    .filter((v): v is string => typeof v === 'string')
    .map((v) => v.trim().toLowerCase())
    .filter((v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
  return [...new Set(validi)];
}

/** Osserva l'elenco dal vivo. Restituisce la funzione per smettere. */
export function osservaDestinatariAvvisiPiattaforma(
  suDestinatari: (destinatari: string[]) => void,
  suErrore: (messaggio: string) => void,
): () => void {
  return onSnapshot(
    doc(db, 'platform_config', DOC_AVVISI_PIATTAFORMA),
    (snap) => suDestinatari(destinatariDelDocumento(snap.data())),
    (e) => suErrore(e.message),
  );
}
